import { addClass, css, removeClass } from '../utils/CssUtils';
import { addEventListener } from '../utils/EventUtils';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import AbstractComponent from './AbstractComponent';
import Logger from '../utils/Logger';

export default class Contact extends AbstractComponent {
    constructor(...args) {
        Logger.log('Contact->constructor()');
        super(...args);

        this.classname = 'c-contact';
        this.isOpen = false;
        this.isOpenClassname = this.getClassname('--is-open');
        this.closeCursorSize = 48;
        this.isCloseCursorShown = false;
        this.isCloseCursorShownClassname = this.getClassname('--is-close-cursor-shown');
        this.initDomElements();
        this.addEventListeners();
        this.fixCssTransitionAtLaunch();
    }

    initDomElements() {
        this.$closeButton = this.$el.querySelector(this.getSelector('__close'));
        this.$closeCursor = this.$el.querySelector(this.getSelector('__close-cursor'));
    }

    addEventListeners() {
        if (this.$closeButton) {
            addEventListener(this.$closeButton, 'click', this.closeContact.bind(this));
        }
        if (this.$closeCursor) {
            addEventListener(window, 'mousemove', this.mouseMoveListener.bind(this));
        }
        addEventListener(this.$el, 'click', this.closeListener.bind(this));
        this.app.addAnchorOpenEventListeners('open-contact', this.toggleContact.bind(this));
    }

    mouseMoveListener(e) {
        this.toggleCloseCursorVisibility(e);
        this.moveCloseCursor(e.clientX, e.clientY);
    }

    toggleCloseCursorVisibility(e) {
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const hoverElement = document.elementFromPoint(e.pageX, (e.pageY - scrollY));
        if (this.$el == hoverElement) {
            this.showCloseCursor();
        } else {
            this.hideCloseCursor();
        }
    }

    moveCloseCursor(x, y) {
        const halfCloseCursorSize = this.closeCursorSize / 2;
        const mouseX = x - halfCloseCursorSize;
        const mouseY = y - halfCloseCursorSize;
        this.$closeCursor.style.transform = 'translate(' + mouseX + 'px, ' + mouseY + 'px)';
    }

    showCloseCursor() {
        if (this.isCloseCursorShown) {
            return;
        }
        this.isCloseCursorShown = true;
        addClass(this.$el, this.isCloseCursorShownClassname);
    }

    hideCloseCursor() {
        if (!this.isCloseCursorShown) {
            return;
        }
        this.isCloseCursorShown = false;
        removeClass(this.$el, this.isCloseCursorShownClassname);
    }

    closeListener(e) {
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const hoverElement = document.elementFromPoint(e.pageX, (e.pageY - scrollY));
        if (this.$el == hoverElement) {
            this.closeContact();
        }
    }

    toggleContact(source) {
        if (source) {
            source.blur();
        }
        if (this.isOpen) {
            this.closeContact();
        } else {
            this.openContact();
        }
    }

    openContact() {
        addClass(this.$el, this.isOpenClassname);
        disableBodyScroll(this.$el);
        this.isOpen = true;
    }

    closeContact() {
        this.hideCloseCursor();
        enableBodyScroll(this.$el);
        removeClass(this.$el, this.isOpenClassname);
        this.isOpen = false;
    }

    fixCssTransitionAtLaunch() {
        const duration = '0.35';
        const easeInOutQuad = 'cubic-bezier( 0.25, 0.46, 0.45, 0.94 )';
        setTimeout(() => css(this.$el, { 'transition': 'transform ' + duration + 's ' + easeInOutQuad + ', opacity ' + duration + 's ' + easeInOutQuad }), 300);
    }

    destroy() { }
}